module.exports = __webpack_public_path__ + "img/40ne.1a64f56b.svg";